import Backbone from 'backbone';
import template from './goal.pug';

export class GoalContextualAttributeView extends Backbone.View {
  initialize({
    deps,
    i18n,
    targetId,
    isMCC,
    scope,
    accountName,
    s$i18n,
    newI18n,
  }) {
    this.deps = deps;
    this.i18n = i18n;
    this.goalId = targetId;
    this.isMCC = isMCC;
    this.scope = scope;
    this.accountName = accountName;
    this.s$i18n = s$i18n;
    this.newI18n = newI18n;
  }


  render({
    showDeliveryStatusPopup,
    recommendationAccountId,
  }) {
    const {
      deps, goalId, i18n, scope, accountName, s$i18n, newI18n,
    } = this;
    const cid = scope.advertiserCustomerId;
    const aid = recommendationAccountId;
    const url = `Customers(${cid})/Accounts(${aid})/Goals(${goalId})`;
    deps.odata.get(url).then((response) => {
      if (response) {
        const trackingStatus = response.TrackingStatus;
        const isAccountLevel = response.IsAccountLevel;
        const goalType = s$i18n.value('Goal', 'Type', response.Type);
        let scopeName;
        if (isAccountLevel) {
          scopeName = i18n.getString(
            'UnifiedEventTracking_Goal_Creation_TrackingType_CurrentAccount',
            { acctname: accountName }
          );
        } else {
          scopeName = i18n.getString('UnifiedEventTracking_Goal_Creation_TrackingType_AllAccounts');
        }

        this.$el.html(template({
          i18n,
          trackingStatus,
          scopeName,
          goalType,
          goalTypeLabel: newI18n.getString(_TL_('Goal type')),
        }));

        showDeliveryStatusPopup(this.el.outerHTML);
      }
    });
    return this;
  }
}
